import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconMobile = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <rect x="1" y="1" width="13" height="17" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <path d="M6.25 3.5H8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M1.25 14H13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M1.25 6H13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export default IconMobile
